export namespace DriverOnboardingStatusConstants {
  export const FULLY_ONBOARDED: string = 'Fully Onboarded';
  export const ONBOARDING: string = 'Onboarding';
}
